module.exports = __webpack_public_path__ + "img/spac-loader.0339d858.gif";